import React from 'react';
import { 
  Box, 
  Grid, 
  Paper, 
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import { 
  Edit as EditIcon,
  ContentCopy as DuplicateIcon,
  Delete as DeleteIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon
} from '@mui/icons-material';
import { isWeekend } from 'date-fns';

const PointageCalendar = ({
  filteredDays, 
  showWeekends,
  renderDayContent,
  handleQuickAddPointage,
  // Ajouter les props pour le menu contextuel
  anchorEl,
  selectedPointage,
  onMenuClose,
  onEditClick,
  onDuplicateClick,
  onFavoriteClick,
  onDeleteClick
}) => {
  return (
    <Box>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${showWeekends ? 7 : 5}, 1fr)`,
        gap: 1,
        mb: 1
      }}>
        {['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', ...(showWeekends ? ['Sam', 'Dim'] : [])].map(day => (
          <Box
            key={day}
            sx={{
              textAlign: 'center',
              fontWeight: 'bold',
              backgroundColor: theme => theme.palette.mode === 'dark' 
                ? theme.palette.background.paper 
                : theme.palette.grey[200],
              color: theme => theme.palette.text.primary,
              p: 1,
              borderRadius: 1,
              border: theme => `1px solid ${theme.palette.divider}`
            }}
          >
            {day}
          </Box>
        ))}
      </Box>

      <Grid container spacing={1} alignItems="stretch">
        {filteredDays.map((day) => (
          <Grid item xs={12 / (showWeekends ? 7 : 5)} key={day.toISOString()} style={{ display: 'flex' }}>
            <Paper
              elevation={1}
              sx={{
                p: 1,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: isWeekend(day) && !showWeekends ? 'transparent' : undefined,
                border: isWeekend(day) && !showWeekends ? 'none' : undefined
              }}
            >
              {renderDayContent(day)}
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Menu contextuel */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onMenuClose}
        MenuListProps={{
          'aria-labelledby': 'pointage-menu'
        }}
      >
        <MenuItem onClick={onEditClick}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Modifier</ListItemText>
        </MenuItem>

        <MenuItem onClick={onDuplicateClick}>
          <ListItemIcon>
            <DuplicateIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Dupliquer</ListItemText>
        </MenuItem>

        <MenuItem onClick={onFavoriteClick}>
          <ListItemIcon>
            {selectedPointage?.is_favorite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
          </ListItemIcon>
          <ListItemText>
            {selectedPointage?.is_favorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
          </ListItemText>
        </MenuItem>

        <MenuItem onClick={onDeleteClick}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Supprimer</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default PointageCalendar;
